import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "gfu-layout-wrapper gfu-layout-wrapper--extranarrow _pb-3 _pt-2 _pt-3--m",
  "data-qa": "project-banner"
}
const _hoisted_2 = {
  class: "gfu-project-banner__title",
  "data-qa": "project-banner-title"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "gfu-project-banner__title-annotation" }
const _hoisted_5 = {
  class: "gfu-project-banner__description",
  "data-qa": "project-banner-description"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_creators_line = _resolveComponent("creators-line")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createElementVNode("a", {
        href: $props.projectHomeUrl,
        class: "gfu-link gfu-link--nofx",
        "data-qa": "project-banner-title-url"
      }, _toDisplayString($props.projectName), 9 /* TEXT, PROPS */, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_creators_line, {
        creator: $setup.mappedCreator,
        "co-creators": $setup.mappedCoCreators,
        "show-as-links": ""
      }, null, 8 /* PROPS */, ["creator", "co-creators"])
    ]),
    _createElementVNode("div", _hoisted_5, _toDisplayString($props.projectShortDescription), 1 /* TEXT */)
  ]))
}